module.exports = __webpack_public_path__ + "5255ac8dbf4d45a726ffbd9a399d100a.svg";